"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isRequired = function isRequired(message) {
  return function (_ref) {
    var field = _ref.field;
    var value = field.value;

    if (value === undefined || value === null) {
      return [false, message];
    }

    if (_typeof(value) === 'object' && !Array.isArray(value) && value.hasOwnProperty('value')) {
      value = value.value;
    }

    if (typeof value === 'string' && !value.trim().length) {
      return [false, message];
    }

    if (field.type && field.type.includes('checkbox-group') && value.length === 0) {
      return [false, message];
    }

    if (field.type === 'checkbox' && typeof value === 'boolean') {
      return [value, message];
    }

    if (field.type === 'meta' && typeof value === 'boolean') {
      return [value, message];
    }

    if (value.length === 0) {
      return [false, message];
    }

    return [true, message || 'Please enter a value.'];
  };
};

var _default = isRequired;
exports.default = _default;
//# sourceMappingURL=isRequired.js.map